export default __webpack_public_path__ + "static/media/img_muslinTwoBunny_yg.207bcd36.jpg";